/**
 * Allows users to update their consent preference.
 */
export function manageConsents(): void {
  window.Didomi?.preferences.show();
}
